/**
 * Shared 'manual_review' classification for workflow-instance readers
 * (999.4741 / 999.4758 / 999.4760).
 *
 * 999.4740 introduced 'manual_review' as the status a workflow instance is
 * routed to when a Stripe-calling step has been in flight past the ~24h
 * idempotency-key window and the recovery scan refuses to replay it — a
 * refund or charge MAY already have executed at the provider and is
 * UNVERIFIED. Per 999.4741 there is NO supported API transition out of it:
 * retryStep requires status === 'failed', cancelWorkflow's status allowlist
 * omits it, rollbackInstance requires 'failed'. So every frontend reader
 * must treat it as TERMINAL (stop waiting/polling for a change that cannot
 * happen) but it is its OWN state — never lump it into "success" (the
 * previous bug: falling through to a generic success/complete branch) and
 * never silently relabel it "failed" either (we don't know that it failed).
 */

export const MANUAL_REVIEW_STATUS = 'manual_review';

/** Statuses that will never receive another automatic transition. */
export const TERMINAL_WORKFLOW_STATUSES = ['completed', 'failed', 'canceled', 'undone', MANUAL_REVIEW_STATUS];

/** Terminal statuses that represent a definite, known outcome (success or failure). */
export const RESOLVED_TERMINAL_STATUSES = ['completed', 'failed', 'canceled', 'undone'];

export function isManualReview(status) {
  return status === MANUAL_REVIEW_STATUS;
}

export function isTerminalWorkflowStatus(status) {
  return TERMINAL_WORKFLOW_STATUSES.includes(status);
}

// Customer-facing copy: must not claim the change succeeded and must not
// claim it failed — neither is known yet. Short, factual, non-alarming.
// No invented support URL or SLA.
export const MANUAL_REVIEW_CUSTOMER_TITLE = 'Your request is being reviewed';
export const MANUAL_REVIEW_CUSTOMER_DETAIL =
  "We need to verify this with our payment provider before confirming it. No action is needed from you right now.";
